import { createFileRoute } from "@tanstack/react-router";

import { ShowHost } from "../features/show/ShowHost";

/** The host's controls. The clock takes the verbs, the stage is what they read. */
export const Route = createFileRoute("/show/host/$clockMount/$stageMount")({
  component: HostCanvas,
});

function HostCanvas() {
  const { clockMount, stageMount } = Route.useParams();
  return (
    <main>
      <ShowHost clockMount={clockMount} stageMount={stageMount} />
    </main>
  );
}
